import { render, staticRenderFns } from "./BrandBase.vue?vue&type=template&id=146346ba&"
import script from "./BrandBase.vue?vue&type=script&lang=js&"
export * from "./BrandBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports